"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var EstateChart_1 = require("@/pages/estate/components/EstateChart");
var EstateChartLegacy_1 = require("@/pages/estate/components/EstateChartLegacy");
var classnames_1 = require("classnames");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var MegaMenu_1 = require("@/pages/common/components/MegaMenu");
var Login_1 = require("@/pages/common/components/Login");
var Signup_1 = require("@/pages/common/components/Signup");
var Bigpopup_1 = require("@/pages/common/components/Bigpopup");
var ExistingLogin_1 = require("@/pages/search/components/ExistingLogin");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var Breadcrumb_1 = require("@/pages/search/components/Breadcrumb");
var EstateState_1 = require("@/pages/estate/states/EstateState");
var format_1 = require("@/utils/format");
var PlaceFeatures_1 = require("@/utils/PlaceFeatures");
var EstateAction_1 = require("@/pages/estate/actions/EstateAction");
var EstateMap_1 = require("@/pages/estate/components/EstateMap");
var GalleryPop_1 = require("@/pages/common/components/GalleryPop");
var PlaceState_1 = require("@/pages/place/states/PlaceState");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var Enquire_1 = require("@/pages/common/components/Enquire");
var ServerSideSchema_1 = require("@/pages/common/components/schema/ServerSideSchema");
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var Testimonial_1 = require("@/pages/common/components/Testimonial");
var Contact_1 = require("@/pages/common/components/contact/Contact");
var marked_1 = require("marked");
var EstateTransactions_1 = require("@/pages/estate/components/EstateTransactions");
var PlaceResultListItems_1 = require("@/pages/place/components/PlaceResultListItems");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.estate), { layout: state.layout, symbol: state.layout.currencies.options.find(function (it) { return it.key === state.layout.currencies.currentCurrencyId; }).symbol, symbolHkd: state.layout.currencies.options.find(function (it) { return it.key === SfilterPriceGroup_1.SfilterCurrency.HKD; }).symbol, langCode: state.layout.language.languages.find(function (it) { return it.id === state.layout.language.current; }).code1, googleApikey: state.layout.googleApi, nameMain: state.estate.name, galleryItems: state.estate.images.map(function (it) { return ({ src: it, thumb: it, text: '' }); }), lang: state.layout.language.languages.find(function (it) { return it.id === state.layout.language.current; }).code1, currencyCode: state.layout.currencies.options.find(function (it) { return it.key === state.layout.currencies.currentCurrencyId; }).code2 })); };
var mapDispatchToProps = function (dispatch) { return ({
    onChartRangeClick: function (i) { return dispatch(EstateAction_1.default.onChartRangeClick(i)); },
    onLocationLabelClick: function (phase, i) { return dispatch(EstateAction_1.default.onLocationLabelClick(phase, i)); },
    onSelectBlock: function (block) { return dispatch(EstateAction_1.default.onSelectBlock(block)); },
    onImageClick: function (src) { return dispatch(EstateAction_1.default.onImageClick(src)); },
    fullsize: function (index) { return dispatch(EstateAction_1.default.fullsize(index)); },
    showPop: function (popState) { return dispatch(EstateAction_1.default.showPop(popState)); },
    setMapType: function (type) { },
    onSelectPhase: function (phaseId) { return dispatch(EstateAction_1.default.onSelectPhase(phaseId)); },
    onContactClicked: function () { return dispatch(EstateAction_1.default.onContactClicked()); },
}); };
var estate = function (props) {
    var _a = React.useState('sale'), activeListingTab = _a[0], setActiveListingTab = _a[1];
    var phaseOtherPhaseStr = props.type === EstateState_1.EstatePhaseType.ESTATE ? props.t.phases : props.t.otherPhases;
    var galleryProps = __assign({}, props);
    delete galleryProps.lat;
    delete galleryProps.lng;
    var menuClass = classnames_1.default([
        'c-sticky-menu',
        {
            'c-sticky-menu--lite': !props.isSticky,
        },
    ]);
    var pageClass = classnames_1.default([
        'l-arch',
        'c-nav--safari',
        'l-arch__topmenu--nosticky',
        {
            'c-nav__menu-main--mobile-active': props.layout.activePanel === LayoutState_1.ActivePanel.TOPMENU,
            'c-nav__menu-setting--mobile-active': props.layout.activePanel === LayoutState_1.ActivePanel.CONFIG,
            'c-calloremail--active': props.layout.callOrEmailActive,
        },
    ]);
    var renderPhase = function (it, i) {
        var phaseClass = classnames_1.default(['o-btn', 'o-btn--flat', 'c-estate__phase', { 'o-btn--active': it.active }]);
        return React.createElement("a", { key: i, className: phaseClass, href: it.url }, it.name);
    };
    var renderNoimage = function (props) {
        if (props.images.length)
            return null;
        var src = props.images[0];
        return (React.createElement("div", { className: "c-estate__img-empty" },
            React.createElement("img", { src: "/res/img/nopic.jpg" })));
    };
    var renderMainImage = function (props) {
        if (!props.images.length)
            return null;
        var src = props.images[0];
        var onImageClick = function () { return props.onImageClick(src); };
        return (React.createElement("div", { className: "c-estate__img-main" },
            React.createElement("img", { alt: props.name, style: { cursor: 'pointer' }, onClick: onImageClick, src: src })));
    };
    var renderSideImages = function (props) {
        if (!props.lat && props.images.length < 2)
            return null;
        var renderImage = function (src, i) {
            var onImageClick = function () { return props.onImageClick(src); };
            return (React.createElement("div", { key: i, className: "c-estate__img-side-img" },
                React.createElement("img", { alt: props.name, style: { cursor: 'pointer' }, onClick: onImageClick, src: src })));
        };
        var getStaticMap = function (lat, lng) { return "https://maps.googleapis.com/maps/api/staticmap?center=" + lat + "," + lng + "&zoom=16&size=300x200&markers=color:0x00b0a8|" + lat + "," + lng + "&maptype=roadmap&key=" + props.googleApikey; };
        var renderEmpty = function (_, i) { return React.createElement("div", { key: "empty-" + i, className: "c-estate__img-side-img" }); };
        var allImages = props.images.slice(1, 4);
        if (props.lat)
            allImages.push(getStaticMap(props.lat, props.lng));
        return (React.createElement("div", { className: "c-estate__img-side" },
            allImages.map(renderImage),
            (new Array(4 - allImages.length).fill('')).map(renderEmpty)));
    };
    var renderBlockUnits = function (props) {
        return (React.createElement("div", { className: "c-estate__fact c-estate__fact--double" },
            React.createElement("ul", { className: "c-estate__fact-list2" },
                props.builtYear > 0 ? (React.createElement("li", { className: "c-estate__fact-list-item2" },
                    React.createElement("h3", { className: "c-estate__fact-list-item-col-label" }, props.t.builtYear),
                    React.createElement("div", { className: "c-estate__fact-list-item-col-value" }, props.builtYear))) : null,
                React.createElement("li", { className: "c-estate__fact-list-item2" },
                    React.createElement("h3", { className: "c-estate__fact-list-item-col-label" }, props.t.blocks),
                    React.createElement("h3", { className: "c-estate__fact-list-item-col-value" }, props.totalBlockCount)),
                React.createElement("li", { className: "c-estate__fact-list-item2" },
                    React.createElement("div", { className: "c-estate__fact-list-item-col-label" }, props.t.units),
                    React.createElement("div", { className: "c-estate__fact-list-item-col-value" }, props.totalUnitCount)))));
    };
    var renderInfoTable = function (props) {
        var renderPhases = function (props) {
            if (!props.phases.length)
                return null;
            var renderPhaseRow = function (phase, i) {
                return (React.createElement("div", { key: i, className: "c-estate__table-tr" },
                    React.createElement("div", { className: "c-estate__table-td c-estate__table-td--name" },
                        React.createElement("a", { target: "_blank", href: phase.url, className: "o-btn o-btn--flat c-estate__phase" }, phase.name)),
                    React.createElement("div", { className: "c-estate__table-td" },
                        React.createElement("span", { className: "u-mobile-hidden" }, props.t.built),
                        " ",
                        phase.completionYear),
                    React.createElement("div", { className: "c-estate__table-td" },
                        phase.floorRange.join(' - '),
                        " ",
                        React.createElement("span", { className: "u-mobile-hidden" }, props.t.floors)),
                    React.createElement("div", { className: "c-estate__table-td" },
                        phase.blockCount,
                        " ",
                        React.createElement("span", { className: "u-mobile-hidden" }, props.t.blocks)),
                    React.createElement("div", { className: "c-estate__table-td" },
                        phase.unitCount,
                        " ",
                        React.createElement("span", { className: "u-mobile-hidden" }, props.t.units))));
            };
            return props.phases.map(renderPhaseRow);
        };
        return props.phases.length ? (React.createElement("div", { className: "c-estate__fact c-estate__fact--double" },
            React.createElement("div", { className: "c-estate__table" },
                React.createElement("div", { className: "c-estate__table-tr c-estate__table-tr--head" },
                    React.createElement("div", { className: "c-estate__table-td c-estate__table-td--name" }),
                    React.createElement("div", { className: "c-estate__table-td" }, props.t.builtYear),
                    React.createElement("div", { className: "c-estate__table-td" }, props.t.floors),
                    React.createElement("div", { className: "c-estate__table-td" }, props.t.blocks),
                    React.createElement("div", { className: "c-estate__table-td" }, props.t.units)),
                renderPhases(props)))) : null;
    };
    var renderSchoolNetInfo = function (props) {
        if (!props.schoolNetPrimary && !props.schoolNetSecondary)
            return null;
        var renderRow = function (text) { return (React.createElement("li", { className: "c-estate__fact-list-item" }, text)); };
        return (React.createElement("div", { className: "c-estate__fact" },
            React.createElement("h3", { className: "c-estate__fact-title" }, props.t.schoolNet),
            React.createElement("ul", { className: "c-estate__fact-list" },
                props.schoolNetPrimary ? renderRow(props.t.primary + " - " + props.schoolNetPrimary) : null,
                props.schoolNetSecondary ? renderRow(props.t.secondary + " - " + props.schoolNetSecondary) : null)));
    };
    var renderFeatures = function (props) {
        if (!props.features || !props.features.length)
            return;
        var renderFeature = function (id, i) {
            var feature = PlaceFeatures_1.features.find(function (it) { return it.type === PlaceFeatures_1.toFeature(id).type; });
            var icon = feature.icon;
            var text = props.tFeature[feature.key] ? props.tFeature[feature.key] : feature.key;
            return (React.createElement("div", { key: i, className: "c-estate__feature-item" },
                React.createElement("span", { className: "c-estate__feature-icon" },
                    React.createElement("span", { className: "fal fa-" + icon })),
                React.createElement("span", { className: "c-estate__feature-text" }, text)));
        };
        return (React.createElement("div", { className: "c-estate__features" },
            React.createElement("h3", { className: "c-estate__feature-title" }, props.t.features),
            React.createElement("div", { className: "c-estate__feature-list" }, props.features.map(renderFeature))));
    };
    var renderTransactionTable = function (props) {
        if (!props.transactions || !props.transactions.length)
            return null;
        var renderMarginCell = function (record) {
            if (!record.priceChangePercent)
                return React.createElement("td", { className: "c-estate__history-td" }, "-");
            var text = Math.ceil(record.priceChangePercent) + "%";
            if (record.priceChangePercent > 0) {
                return (React.createElement("td", { className: "c-estate__history-td c-estate__history-td--win" },
                    React.createElement("span", { className: "fas fa-caret-up" }),
                    "\u00A0",
                    React.createElement("span", null, text),
                    "\u00A0",
                    React.createElement("span", { className: "c-estate__history-label--sm" },
                        "(",
                        record.priceChangeSinceDate,
                        ")")));
            }
            return (React.createElement("td", { className: "c-estate__history-td c-estate__history-td--lose" },
                React.createElement("span", { className: "fas fa-caret-down" }),
                "\u00A0",
                React.createElement("span", null, text),
                "\u00A0",
                React.createElement("span", { className: "c-estate__history-label--sm" },
                    "(",
                    record.priceChangeSinceDate,
                    ")")));
        };
        var renderTableRow = function (record, i) {
            return (React.createElement("tr", { key: i, className: "c-estate__history-tr", style: { gridTemplateColumns: '1fr 2fr 1fr 1fr 1fr 1fr' } },
                React.createElement("td", { className: "c-estate__history-td" },
                    React.createElement("span", { className: "u-mobile-hidden" }, record.date),
                    React.createElement("span", { className: "u-mobile-only" }, record.date)),
                React.createElement("td", { className: "c-estate__history-td" },
                    React.createElement("span", { className: "u-mobile-hidden" }, [record.phase, record.block, "" + record.floor + record.unit].filter(function (it) { return it; }).join(' / ')),
                    React.createElement("span", { className: "u-mobile-only" }, [record.block, "" + record.floor + record.unit].filter(function (it) { return it; }).join('/'))),
                React.createElement("td", { className: "c-estate__history-td c-estate__history-td--price" }, format_1.default.currencySale(record.price, props.lang, props.symbolHkd)),
                renderMarginCell(record),
                React.createElement("td", { className: "c-estate__history-td u-mobile-hidden" }, record.size ? record.size + " " + (record.sizeUnit === 'g' ? "(" + props.t.grossAbbr + ")" : "(" + props.t.saleableAbbr + ")") : '-'),
                React.createElement("td", { className: "c-estate__history-td u-mobile-hidden" }, record.size ? format_1.default.currencyPpsf(Math.floor(record.price / record.size), props.symbol) + " " + (record.sizeUnit === 'g' ? "(" + props.t.grossAbbr + ")" : "(" + props.t.saleableAbbr + ")") + " " : '')));
        };
        return (React.createElement("div", { id: "transactions", className: "l-estate__section" },
            React.createElement("div", { className: "l-estate__history" },
                React.createElement("h2", { className: "c-estate__section-title" }, props.t.transactionRecords),
                React.createElement("table", { className: "c-estate__history" },
                    React.createElement("thead", null,
                        React.createElement("tr", { className: "c-estate__history-tr c-estate__history-tr--head", style: { gridTemplateColumns: '1fr 2fr 1fr 1fr 1fr 1fr' } },
                            React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.t.date),
                            React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.t.property),
                            React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.t.price),
                            React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head" }, props.t.margin),
                            React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head u-mobile-hidden" }, props.t.size),
                            React.createElement("th", { className: "c-estate__history-td c-estate__history-td--head u-mobile-hidden" }, props.t.ppsf))),
                    React.createElement("tbody", null, props.transactions.map(renderTableRow))))));
    };
    var renderChart = function (props) {
        if (!props.charts || !props.charts.length)
            return null;
        var renderLabel = function (chart, i) {
            var labelClass = classnames_1.default(['c-estate__label', 'o-btn', 'o-btn--switch', { 'o-btn--active': chart.active }]);
            var onClick = function () { return props.onChartRangeClick(i); };
            return (React.createElement("div", { key: i, className: labelClass },
                React.createElement("a", { style: { cursor: 'pointer' }, onClick: onClick }, chart.title)));
        };
        return (React.createElement("div", { className: "l-estate__section" },
            React.createElement("h2", { className: "c-estate__section-title" }, props.t.trends),
            React.createElement("div", { className: "c-estate__labels" }, props.charts.map(renderLabel)),
            React.createElement("div", { className: "c-estate__chart", style: { cursor: 'pointer' } },
                React.createElement(EstateChartLegacy_1.default, null))));
    };
    var renderPhaseLabel = function (props) {
        if (!props.phases || !props.phases.length)
            return null;
        var renderLabel = function (label, i) {
            var labelClass = classnames_1.default(['c-estate__label', 'o-btn', 'o-btn--switch', {
                    'o-btn--active': label.mapActive,
                }]);
            var onClick = function () { return props.onLocationLabelClick(label, i); };
            return (React.createElement("div", { key: i, style: { cursor: 'pointer' }, className: labelClass },
                React.createElement("a", { onClick: onClick }, label.name)));
        };
        var allActive = props.phases.filter(function (it) { return it.mapActive; }).length === 0;
        return (React.createElement("div", { className: "c-estate__labels" },
            renderLabel({ name: props.t.all, url: '', mapActive: allActive }, -1),
            props.phases.map(renderLabel)));
    };
    var renderBlocks = function (props) {
        if (!props.blocks || !props.blocks.length)
            return null;
        var renderBlockRows = function (block, i) {
            var onSelectBlock = function () { return props.onSelectBlock(block); };
            return (React.createElement("div", { key: i, onClick: onSelectBlock, onMouseOver: onSelectBlock, className: "c-estate__building" },
                React.createElement("div", { className: "c-estate__building-name" },
                    React.createElement("span", { className: "c-estate__building-name-icon fal fa-map-marker-alt" }),
                    block.name),
                React.createElement("div", { className: "c-estate__building-action" },
                    React.createElement("a", { target: "_blank", className: "o-btn o-btn--flat c-estate__building-action-link", href: block.url || '#' },
                        React.createElement("span", { className: "fal fa-external-link" }),
                        "\u00A0 ",
                        props.t.viewMore))));
        };
        if (props.phases && props.phases.length) {
            var renderBlockInPhase = function (phase, i) {
                var blocks = props.blocks.filter(function (it) { return it.parentPhaseId === phase.id; }).sort(function (it) { return it.isPropertyId ? -1 : 1; });
                return (React.createElement("div", { id: "phase-" + i, key: i },
                    React.createElement("div", { className: "c-estate__building c-estate__building--header" },
                        React.createElement("div", { className: "c-estate__building-name" }, phase.name)),
                    blocks.map(renderBlockRows)));
            };
            return props.phases.map(renderBlockInPhase);
        }
        return props.blocks.map(renderBlockRows);
    };
    var propsToAvailableProps = function (props, filterType) { return ({
        filterType: filterType,
        t: props.tPlace,
        availableShowBuildingName: props.availableShowBuildingName,
        currentSort: filterType === SfilterTypeGroup_1.SfilterType.RENT ? props.availableRentSort : props.availableSaleSort,
        currentOrder: filterType === SfilterTypeGroup_1.SfilterType.RENT ? props.availableRentOrder : props.availableSaleOrder,
        priceSortField: filterType === SfilterTypeGroup_1.SfilterType.RENT ? PlaceState_1.AvailableSortType.LEASE_PRICE : PlaceState_1.AvailableSortType.SALE_PRICE,
        ppsfSortField: filterType === SfilterTypeGroup_1.SfilterType.RENT ? PlaceState_1.AvailableSortType.LEASE_PRICE_PER_SQFT : PlaceState_1.AvailableSortType.SALE_PRICE_PER_SQFT,
        currencyCode: props.currencyCode,
        showFollow: false,
        followId: 0,
        followName: props.name,
        results: filterType === SfilterTypeGroup_1.SfilterType.RENT ? props.availablePropertiesRent : props.availablePropertiesSale,
        lang: props.lang,
    }); };
    var renderSaleList = function (props) {
        var placeAvailableProps = propsToAvailableProps(props, SfilterTypeGroup_1.SfilterType.BUY);
        return React.createElement(PlaceResultListItems_1.default, __assign({}, placeAvailableProps, { lang: props.lang, symbol: props.symbol, googleApikey: props.googleApikey }));
    };
    var renderRentList = function (props) {
        var placeAvailableProps = propsToAvailableProps(props, SfilterTypeGroup_1.SfilterType.RENT);
        return React.createElement(PlaceResultListItems_1.default, __assign({}, placeAvailableProps, { lang: props.lang, symbol: props.symbol, googleApikey: props.googleApikey }));
    };
    var renderPhaseDropDown = function (props) {
        var renderPhaseOption = function (phase, i) {
            return (React.createElement("option", { value: phase.id, key: i }, phase.name));
        };
        var onPhaseChange = function (e) { return props.onSelectPhase(Number(e.target.value)); };
        return (React.createElement("div", { className: "c-estate__dropdown-wrap" },
            React.createElement("select", { value: -1, onChange: onPhaseChange, className: "c-estate__dropdown" },
                React.createElement("option", { disabled: true, hidden: true, value: -1 }, props.t.selectPhases),
                props.phases.map(renderPhaseOption)),
            React.createElement("span", { className: "fal fa-chevron-down" })));
    };
    var renderForSaleCount = function (props) { return props.forSaleCount ? (React.createElement("div", { className: "c-estate__count-cell" },
        React.createElement("div", { className: "c-estate__count-title" }, props.t.forSale),
        React.createElement("div", { className: "c-estate__count-value" }, props.forSaleCount),
        React.createElement("div", { className: "c-estate__count-action" },
            React.createElement("a", { className: "o-btn o-btn--flat", href: props.viewSaleLink }, props.t.viewMore)))) : null; };
    var renderForRentCount = function (props) { return props.forRentCount ? (React.createElement("div", { className: "c-estate__count-cell" },
        React.createElement("div", { className: "c-estate__count-title" }, props.t.forRent),
        React.createElement("div", { className: "c-estate__count-value" }, props.forRentCount),
        React.createElement("div", { className: "c-estate__count-action" },
            React.createElement("a", { className: "o-btn o-btn--flat", href: props.viewRentLink }, props.t.viewMore)))) : null; };
    var renderFigures = function (props) {
        return props.ppsf && props.transactionCount ? (React.createElement("div", { className: "l-estate__figures" },
            React.createElement("div", { className: "c-estate__info" },
                renderPpsfCell(props),
                renderTransactionCell(props)),
            React.createElement("div", { className: "c-estate__count" },
                renderForSaleCount(props),
                renderForRentCount(props)))) : null;
    };
    var renderPpsfCell = function (props) {
        return props.ppsf ? (React.createElement("div", { className: "c-estate__cell" },
            React.createElement("div", { className: "c-estate__cell-main" },
                React.createElement("div", { className: "c-estate__cell-title" }, props.t.ppsf),
                React.createElement("div", { className: "c-estate__cell-value" }, format_1.default.currencyPpsf(props.ppsf, props.symbol)),
                props.ppsfMin ? (React.createElement("div", { className: "c-estate__cell-value2" },
                    format_1.default.currencyPpsf(props.ppsfMin, props.symbol),
                    " - ",
                    format_1.default.currencyPpsf(props.ppsfMax, ''))) : null,
                React.createElement("div", { className: "c-estate__cell-date c-estate__cell-caption" }, props.ppsfTime)),
            props.ppsfChangePercent ? (React.createElement("div", { className: "c-estate__cell-side" },
                React.createElement("div", { className: "c-estate__cell-count " + (props.ppsfChangePercent > 0 ? 'c-estate__cell--green' : 'c-estate__cell--red') },
                    React.createElement("span", { className: "fal " + (props.ppsfChangePercent > 0 ? 'fa-arrow-up' : 'fa-arrow-down') }),
                    "\u00A0", props.ppsfChangePercent + "%"),
                React.createElement("div", { className: "c-estate__cell-caption" },
                    "(",
                    props.t.compareTo,
                    " ",
                    props.ppsfCompareTo,
                    ")"))) : null)) : null;
    };
    var renderTransactionCell = function (props) { return props.transactionCount ? (React.createElement("div", { className: "c-estate__cell" },
        React.createElement("div", { className: "c-estate__cell-main" },
            React.createElement("div", { className: "c-estate__cell-title" }, props.t.transactions),
            React.createElement("div", { className: "c-estate__cell-value" },
                format_1.default.currencyDetailSale(props.transactionPriceMin * 1000000, props.lang, props.symbol),
                "-",
                format_1.default.currencyDetailSale(props.transactionPriceMax * 1000000, props.lang, '')),
            React.createElement("div", { className: "c-estate__cell-date c-estate__cell-caption" }, props.transactionTime)),
        props.transactionCountChangePercent ? (React.createElement("div", { className: "c-estate__cell-side" },
            React.createElement("div", { className: "c-estate__cell-count" }, props.transactionCount),
            React.createElement("div", { className: "c-estate__cell-count2 " + (props.transactionCountChangePercent > 0 ? 'c-estate__cell--green' : 'c-estate__cell--red') },
                React.createElement("span", { className: "fal " + (props.transactionCountChangePercent > 0 ? 'fa-arrow-up' : 'fa-arrow-down') }),
                "\u00A0",
                props.transactionCountChangePercent,
                "%"),
            React.createElement("div", { className: "c-estate__cell-caption" },
                "(",
                props.t.compareTo,
                " ",
                props.transactionCountCompareTo,
                ")"))) : null)) : null; };
    var renderDescription = function (props) {
        if (!props.description)
            return null;
        var descriptionHtml = marked_1.marked.parse(props.description);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "c-estate__quote" },
                React.createElement("span", { className: "fas fa-quote-left" })),
            React.createElement("div", { className: "c-estate__description", dangerouslySetInnerHTML: { __html: descriptionHtml } })));
    };
    var renderCombinedListingsSection = function (props) {
        var hasSaleProperties = props.availablePropertiesSale && props.availablePropertiesSale.length > 0;
        var hasRentProperties = props.availablePropertiesRent && props.availablePropertiesRent.length > 0;
        if (!hasSaleProperties && !hasRentProperties)
            return null;
        var _a = React.useState(hasSaleProperties ? 'sale' : 'rent'), activeListingTab = _a[0], setActiveListingTab = _a[1];
        var renderTabButton = function (tabType, label, isAvailable) {
            if (!isAvailable)
                return null;
            var tabClass = classnames_1.default([
                'okay-tabs-btn',
                { 'okay-tabs-btn--active': activeListingTab === tabType }
            ]);
            return (React.createElement("a", { key: tabType, onClick: function () { return setActiveListingTab(tabType); }, className: tabClass }, label));
        };
        var renderActiveContent = function () {
            if (activeListingTab === 'sale' && hasSaleProperties) {
                return (React.createElement("div", { className: "c-tableview c-tableview--extra", style: { paddingTop: '20px' } }, renderSaleList(props)));
            }
            else if (activeListingTab === 'rent' && hasRentProperties) {
                return (React.createElement("div", { className: "c-tableview c-tableview--extra", style: { paddingTop: '20px' } }, renderRentList(props)));
            }
            return null;
        };
        return (React.createElement("div", { className: "l-pad--6" },
            React.createElement("div", { className: "l-container l-container--lr" },
                React.createElement("div", { className: "l-container__main" },
                    React.createElement("div", { className: "l-estate__listing-tabs" },
                        React.createElement("h2", null,
                            props.name,
                            " - ",
                            props.t.availableListings),
                        React.createElement("div", { className: "okay-tabs" },
                            renderTabButton("sale", props.t.forSale, hasSaleProperties),
                            renderTabButton("rent", props.t.forRent, hasRentProperties))),
                    renderActiveContent()))));
    };
    var renderNearbyPropertiesSection = function (props) {
        var hasNearbyRentProperties = props.nearbyPropertiesRent && props.nearbyPropertiesRent.length > 0;
        var hasNearbySaleProperties = props.nearbyPropertiesSale && props.nearbyPropertiesSale.length > 0;
        if (!hasNearbyRentProperties && !hasNearbySaleProperties)
            return null;
        var _a = React.useState(hasNearbySaleProperties ? 'sale' : 'rent'), activeNearbyTab = _a[0], setActiveNearbyTab = _a[1];
        var renderNearbyTabButton = function (tabType, label, isAvailable) {
            if (!isAvailable)
                return null;
            var tabClass = classnames_1.default([
                'okay-tabs-btn',
                { 'okay-tabs-btn--active': activeNearbyTab === tabType }
            ]);
            return (React.createElement("a", { key: tabType, onClick: function () { return setActiveNearbyTab(tabType); }, className: tabClass }, label));
        };
        var renderNearbyActiveContent = function () {
            if (activeNearbyTab === 'sale' && hasNearbySaleProperties) {
                var nearbyProps = __assign(__assign({}, propsToAvailableProps(props, SfilterTypeGroup_1.SfilterType.BUY)), { results: props.nearbyPropertiesSale, availableShowBuildingName: true });
                return React.createElement(PlaceResultListItems_1.default, __assign({}, nearbyProps, { symbol: props.symbol, googleApikey: props.googleApikey }));
            }
            else if (activeNearbyTab === 'rent' && hasNearbyRentProperties) {
                var nearbyProps = __assign(__assign({}, propsToAvailableProps(props, SfilterTypeGroup_1.SfilterType.RENT)), { results: props.nearbyPropertiesRent, availableShowBuildingName: true });
                return React.createElement(PlaceResultListItems_1.default, __assign({}, nearbyProps, { symbol: props.symbol, googleApikey: props.googleApikey }));
            }
            return null;
        };
        return (React.createElement("div", { className: "l-pad--6" },
            React.createElement("div", { className: "l-container l-container--lr" },
                React.createElement("div", { className: "l-container__main" },
                    React.createElement("div", { className: "l-estate__listing-tabs" },
                        React.createElement("h2", { className: "c-estate__section-title", style: { margin: 0 } }, props.t.nearbyProperties),
                        React.createElement("div", { className: "okay-tabs" },
                            renderNearbyTabButton('sale', props.t.forSale, hasNearbySaleProperties),
                            renderNearbyTabButton('rent', props.t.forRent, hasNearbyRentProperties))),
                    React.createElement("div", { className: "c-tableview c-tableview--extra", style: { paddingTop: '20px' } }, renderNearbyActiveContent())))));
    };
    var renderPhasesRow = function (props) {
        return props.phases && props.phases.length ? (React.createElement("div", { className: "l-estate__phases" },
            React.createElement("div", { className: "c-estate__selector u-mobile-only" }, renderPhaseDropDown(props)),
            React.createElement("div", { className: "c-estate__phases" },
                React.createElement("div", { className: "c-estate__phase-left" },
                    React.createElement("span", { className: "c-estate__phase-label" },
                        phaseOtherPhaseStr,
                        ":")),
                React.createElement("div", { className: "c-estate__phase-right" }, props.phases.map(renderPhase))))) : null;
    };
    return (React.createElement("div", { className: pageClass },
        React.createElement("div", { className: "l-arch__topmenu" },
            React.createElement(MegaMenu_1.default, { nobottom: true })),
        React.createElement("div", { id: "estate" },
            React.createElement("div", { className: "l-pad l-pad--2" },
                React.createElement("div", { className: "l-section l-section--withbg" },
                    React.createElement("div", { className: "l-container l-container--lg l-container--lr u-mobile-hidden l-pad-top l-pad--1half t--darker" },
                        React.createElement(Breadcrumb_1.default, null)))),
            React.createElement("div", { className: "l-estate" },
                React.createElement("div", { className: "l-estate__section" },
                    React.createElement("div", { className: "l-estate__head" },
                        React.createElement("h1", { className: "l-estate__header c-estate__header" },
                            React.createElement("span", { className: "c-estate__title u-bold" }, props.name),
                            React.createElement("span", { className: "c-estate__title" }, props.nameAlt),
                            React.createElement("span", { className: "c-estate__overview-label" }, props.type === EstateState_1.EstatePhaseType.ESTATE ? props.t.estate : props.t.phase),
                            "\u00A0"),
                        React.createElement("div", { className: "l-estate__ctas u-mobile-hidden" },
                            React.createElement("button", { onClick: props.onContactClicked, className: "o-btn o-btn--cta" },
                                React.createElement("span", { className: "fal fa-phone-alt" }),
                                "\u00A0",
                                props.t.contact))),
                    React.createElement("div", { className: "l-estate__address" },
                        React.createElement("div", { className: "c-estate__address" },
                            React.createElement("span", { className: "fal fa-map-marker-alt" }),
                            "\u00A0",
                            props.address)),
                    renderPhasesRow(props),
                    React.createElement("div", { className: "l-estate__main" },
                        React.createElement("div", { className: "l-estate__images" },
                            React.createElement("div", { className: "c-estate__img" },
                                renderNoimage(props),
                                renderMainImage(props),
                                renderSideImages(props))),
                        renderFigures(props))),
                React.createElement("div", { id: "stickymenu", className: menuClass },
                    React.createElement("div", { id: "stickytopbar", className: "c-sticky-menu--sticky t--contrast" },
                        React.createElement("div", { className: "c-sticky-menu__container" },
                            React.createElement("div", { className: "l-container l-container--lr l-container--compact" },
                                React.createElement("div", { className: "l-container__main c-sticky-menu__group" },
                                    React.createElement("div", { className: "c-sticky-menu__group-main" },
                                        React.createElement("a", { title: props.name, href: "#", className: "c-sticky-menu__item c-sticky-menu__item--title c-sticky-menu__link c-sticky-menu__link--nounder" },
                                            props.name,
                                            " - ",
                                            props.nameAlt))),
                                React.createElement("div", { className: "l-container__side c-sticky-menu__group" },
                                    React.createElement("div", { className: "c-sticky-menu__group-side" },
                                        React.createElement("a", { href: "#facts", className: "c-sticky-menu__item c-sticky-menu__item--secondary" },
                                            React.createElement("span", { className: "c-sticky-menu__link" }, props.t.facts)),
                                        React.createElement("a", { href: "#transactions", className: "c-sticky-menu__item c-sticky-menu__item--secondary" },
                                            React.createElement("span", { className: "c-sticky-menu__link" }, props.t.transactions)),
                                        React.createElement("a", { href: "#locations", className: "c-sticky-menu__item c-sticky-menu__item--secondary" },
                                            React.createElement("span", { className: "c-sticky-menu__link" }, props.t.location)),
                                        React.createElement("a", { href: "#listings", className: "c-sticky-menu__item c-sticky-menu__item--secondary" },
                                            React.createElement("span", { className: "c-sticky-menu__link" }, props.t.availableListings)),
                                        React.createElement("div", { className: "u-mobile-only-force c-sticky-menu__item c-sticky-menu__item--primary" },
                                            React.createElement("a", { href: "#listings", className: "c-sticky-menu__link" }, props.t.availableListings))))))),
                    React.createElement("div", null,
                        React.createElement("div", { id: "facts", className: "l-estate__bg" },
                            React.createElement("div", { className: "l-estate__section" },
                                React.createElement("div", { className: "l-estate__fact" },
                                    React.createElement("div", { className: "l-estate__fact-title" },
                                        React.createElement("h2", { className: "c-estate__fact-head" }, props.t.facts)),
                                    React.createElement("div", { className: "l-estate__fact-body" },
                                        renderDescription(props),
                                        React.createElement("div", { className: "c-estate__facts" },
                                            renderBlockUnits(props),
                                            renderInfoTable(props),
                                            renderSchoolNetInfo(props)),
                                        renderFeatures(props)))))),
                    props.isLegacyChart ? renderChart(props) : React.createElement(EstateChart_1.default, null),
                    props.isLegacyTransaction ? renderTransactionTable(props) : React.createElement(EstateTransactions_1.default, null),
                    React.createElement("div", { id: "locations", className: "l-estate__bg" },
                        React.createElement("div", { className: "l-estate__section" },
                            React.createElement("div", { className: "l-estate__map" },
                                React.createElement("h2", { className: "c-estate__section-title" },
                                    props.name,
                                    " - ",
                                    props.t.location),
                                renderPhaseLabel(props),
                                React.createElement("div", { className: "c-estate__location" },
                                    React.createElement("div", { className: "c-estate__map" },
                                        React.createElement("div", { className: "c-estate__map-body" },
                                            React.createElement(EstateMap_1.default, null))),
                                    React.createElement("div", { className: "c-estate__building-groups" },
                                        React.createElement("div", { id: "blocks", className: "c-estate__buildings" }, renderBlocks(props))))))),
                    React.createElement("div", { id: "listings" }, renderCombinedListingsSection(props)),
                    renderNearbyPropertiesSection(props),
                    React.createElement(Contact_1.default, { mobileHidden: false }),
                    React.createElement(Testimonial_1.default, null),
                    React.createElement(GalleryPop_1.galleryPop, __assign({}, galleryProps))))),
        React.createElement(Megafoot_1.default, null),
        React.createElement(ExistingLogin_1.default, null),
        React.createElement(Signup_1.default, null),
        React.createElement(Login_1.default, null),
        React.createElement(Enquire_1.default, null),
        React.createElement(Bigpopup_1.default, null),
        React.createElement(ServerSideSchema_1.default, null)));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(estate);
